import barba from '@barba/core';
import EmblaCarousel from 'embla-carousel';
import Autoplay from 'embla-carousel-autoplay';
import AutoScroll from 'embla-carousel-auto-scroll';
import ClassNames from 'embla-carousel-class-names';

function carousel_mk2()
{
    if (!customElements.get('embla-carousel'))
    {
        customElements.define(
            'embla-carousel',
            class EmblaCarouselMK2 extends HTMLElement {
                constructor()
                {
                    super();
                    this.elements = {
                        viewport: this.querySelector('.emblaCarousel'),
                        container: this.querySelector('.emblaCarousel__container'),
                        pips: this.querySelector('.emblaCarousel__pips'),
                        prevButton: this.querySelector('.embla__prev'),
                        nextButton: this.querySelector('.embla__next')
                    }


                    // Add dots
                    const addDotBtnsAndClickHandlers = (emblaApi, dotsNode) => {
                        let dotNodes = [];
                        
                        const addDotBtnsWithClickHandlers = () => {
                            dotsNode.innerHTML = emblaApi
                            .scrollSnapList()
                            .map(() => '<button class="embla__dot" type="button"></button>')
                            .join('');
                        
                            const scrollTo = (index) => {
                                emblaApi.scrollTo(index);
                            }
                        
                            dotNodes = Array.from(dotsNode.querySelectorAll('.embla__dot'));
                            dotNodes.forEach((dotNode, index) => {
                                dotNode.addEventListener('click', () => scrollTo(index), false);
                            });
                        }
                        
                        const toggleDotBtnsActive = () => {
                            const previous = emblaApi.previousScrollSnap();
                            const selected = emblaApi.selectedScrollSnap();
                            dotNodes[previous].classList.remove('embla__dot--selected');
                            dotNodes[selected].classList.add('embla__dot--selected');
                        }
                        
                        emblaApi
                            .on('init', addDotBtnsWithClickHandlers)
                            .on('reInit', addDotBtnsWithClickHandlers)
                            .on('init', toggleDotBtnsActive)
                            .on('reInit', toggleDotBtnsActive)
                            .on('select', toggleDotBtnsActive);
                        
                        return () => {
                            dotsNode.innerHTML = ''
                        }
                    }


                    // Data Options
                    let autoplay = this.elements.viewport.dataset.autoplay || false;
                    let loop = this.elements.viewport.dataset.loop || false;
                    let containScroll = this.elements.viewport.dataset.containscroll || "trimSnaps";
                    const pips = this.elements.viewport.dataset.pips || false;
                    const continuous = this.elements.viewport.dataset.continuous || false;
                    const autoscrollspeed = this.elements.viewport.dataset.autoscrollSpeed || 0;
                    const align = this.elements.viewport.dataset.align || "center";
                    const navigation = this.elements.viewport.dataset.navigation || "false";
                    const PLUGINS = [ClassNames()];

                    if (continuous == true)
                    {
                        loop = true;
                        autoplay = true;
                        PLUGINS.push(AutoScroll({ startDelay: 300, stopOnInteraction: false, stopOnMouseEnter: false, speed: autoscrollspeed }));
                    }

                    if (autoplay == true)
                    {
                        PLUGINS.push(Autoplay({ delay: 12000 }));
                    }

                    if (containScroll == "false")
                    {
                        containScroll = false;
                    }


                    // Embla Options
                    const OPTIONS = { loop: loop, duration: 30, align: align, containScroll: containScroll, slidesToScroll: "auto" }

                    const viewportNodeCarousel = this.elements.viewport;
                    const dotsNode = this.elements.pips;
                    const emblaApi = EmblaCarousel(viewportNodeCarousel, OPTIONS, PLUGINS);

                    if (pips == true)
                    {
                        const removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(
                            emblaApi,
                            dotsNode
                        );
                          
                        emblaApi.on('destroy', removeDotBtnsAndClickHandlers);
                    }

                    if (navigation == "true")
                    {
                        // Add click listeners
                        this.elements.prevButton.addEventListener('click', emblaApi.scrollPrev, false);
                        this.elements.nextButton.addEventListener('click', emblaApi.scrollNext, false);
                    }
                }
            }
        );
    }
}

barba.hooks.enter((data) => {

    carousel_mk2();

});

carousel_mk2();